// ##### Imports
import { StatusMessageResultDto } from './../../../../general/project.service';
import { UserService } from 'src/app/services/user.service';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NotificationService } from 'src/app/services/notification.service';
import { EsoService } from '../../../eso.service';
import { SimulateMultiResult } from '../../models/simulate-multi-result.model';
import { UtilsService } from 'src/app/services/utils.service';
import { confirm } from 'devextreme/ui/dialog';
import { SimulateMultiTrainingResult } from '../../models/simulate-multi-training-result.model';
import { SignalRService } from 'src/app/services/signal-r.service';
import { Subscription } from 'rxjs';
import { auditTime } from 'rxjs/operators';

@Component({
	selector: 'app-simulate-multi-results-pop-up',
	templateUrl: './simulate-multi-results-pop-up.component.html',
	styleUrls: ['./simulate-multi-results-pop-up.component.scss'],
	host: {
		class: 'host-class'
	},
	standalone: false
})
export class SimulateMultiResultsPopUpComponent implements OnInit, AfterViewInit, OnDestroy {
	@Output() public visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	private _visible: boolean = false;
	@Input()
	public set visible(value: boolean) {
		this._visible = value;

		this.visibleChange.emit(this._visible);
	}
	public get visible(): boolean {
		return this._visible;
	}

	public simulateMultiResultsInProgress: SimulateMultiResult[] = [];

	public simulateMultiResults: SimulateMultiResult[] = [];

	public progressPct = 0;
	public completed = 0;
	public total = 0;
	private subs = new Subscription();
	private simId: number;

	private joinedSimIds = new Set<number>()

	public initializeSimulateMultiResultsDataGrid(): Promise<SimulateMultiResult[]> {

		const $this = this;


		const getSimulateMultiResultsObservable$ = this._esoService.getSimulateMultiResults(this.simulateMultiResults.length === 0 ? -1 : this.simulateMultiResults[0].Id, {showLoadingIndicator:false, responseLoggingEnabled: false});

		return new Promise(
			(resolve, reject) => {
				getSimulateMultiResultsObservable$.subscribe(
					{
						next: (response) => {

							for (let a = 0; a < response.length; a++) {
								response[a].UserName = this._userService.users?.find((user) => user.userID === response[a].UserId)?.userName ?? "USER NOT FOUND";

								if (response[a].EndTime) {
									response[a].CompletionTime = UtilsService.formatSecondsToTime(UtilsService.dateDifferenceInSeconds(response[a].StartTime, response[a].EndTime));
								}
							}

							this.simulateMultiResults = [...(response.reverse()), ...this.simulateMultiResults];

							this.simulateMultiResults.sort((a, b) => a.Id > b.Id ? -1 : 1);

							this.simulateMultiResultsInProgress = [];

							for (let a = 0; a < this.simulateMultiResults.length; a++) {
								const simulateMultiResult = this.simulateMultiResults[a];

								if (simulateMultiResult.Status === "In Progress" && simulateMultiResult.SimulationsCompletedQuantity < simulateMultiResult.SimulationsQuantity) {
									this.simulateMultiResultsInProgress.push(simulateMultiResult);
								}
							}

							this.joinGroupsForInProgress();

							resolve(this.simulateMultiResults);
						},
						error: (error) => {
							console.error(error);

							$this._notificationService.error(error);

							reject(error);
						}
					}
				);
			}
		);
	}

	public simulateMultiTrainingResultsInProgress: SimulateMultiTrainingResult[] = [];

	public simulateMultiTrainingResults: SimulateMultiTrainingResult[] = [];

	public initializeSimulateMultiTrainingResultsDataGrid(): Promise<SimulateMultiTrainingResult[]> {

		const $this = this;

		const getSimulateMultiTrainingResultsObservable$ = this._esoService.getSimulateMultiTrainingResults(this.simulateMultiTrainingResults.length === 0 ? -1 : this.simulateMultiTrainingResults[0].Id, {showLoadingIndicator:false, responseLoggingEnabled: false});

		return new Promise(
			(resolve, reject) => {
				getSimulateMultiTrainingResultsObservable$.subscribe(
					(response) => {

						// Initialize username for all new simulation results in response.
						for (let a = 0; a < response.length; a++) {
							response[a].UserName = this._userService.users?.find((user) => user.userID === response[a].UserId)?.userName ?? "USER NOT FOUND";

							if (response[a].EndTime) {
								response[a].CompletionTime = UtilsService.formatSecondsToTime(UtilsService.dateDifferenceInSeconds(response[a].StartTime, response[a].EndTime));
							}
						}

						this.simulateMultiTrainingResults = [...(response.reverse()), ...this.simulateMultiTrainingResults];



						this.simulateMultiTrainingResults.sort((a, b) => a.Id > b.Id ? -1 : 1);

						this.simulateMultiTrainingResultsInProgress = [];

						for (let a = 0; a < this.simulateMultiTrainingResults.length; a++) {
							const simulateMultiTrainingResult = this.simulateMultiTrainingResults[a];

							if (simulateMultiTrainingResult.Status === "In Progress" && simulateMultiTrainingResult.IterationsCompletedQuantity < simulateMultiTrainingResult.IterationsQuantity) {
								this.simulateMultiTrainingResultsInProgress.push(simulateMultiTrainingResult);
							}
						}


						resolve(this.simulateMultiTrainingResults);
					},
					(error) => {
						console.error(error);

						$this._notificationService.error(error);

						reject(error);
					}
				);
			}
		);
	}

	private includes(array: any, value: any) {
		if (!array) {
			return false;
		}

		for (let a = 0; a < array.length; a++) {
			if (array[a] === value) {
				return true;
			}
		}

		return false;
	}

	private async joinGroupsForInProgress(): Promise<void> {
		try {
			await this._signalRService.startConnection();

			for (const r of this.simulateMultiResultsInProgress) {
				if (!this.joinedSimIds.has(r.Id)) {
					await this._signalRService.joinSimulationGroup(r.Id);
					this.joinedSimIds.add(r.Id);
				}
			}
		} catch (e) {
			console.error('Failed to join simulation groups', e);
		}
	}

	private async leaveAllJoinedGroups(): Promise<void> {
		for (const id of this.joinedSimIds) {
			try { await this._signalRService.leaveSimulationGroup(id); } catch {}
		}
		this.joinedSimIds.clear();
	}

	public onCellPrepared(evt: any): void {
		// Remove delete button when the simulation is not in progress.
		if (evt.column.command === 'edit' && this.includes(evt.cellElement.firstElementChild?.classList, 'dx-icon-clear') && evt.rowType === 'data') {
			if (evt.data.Status !== 'In Progress') {
				evt.cellElement.firstElementChild.remove();
			}
		}
	}

	public onSimulationCancel(evt: any): void {

		const data = evt.row.data;

		confirm('Are you sure?', 'Cancel Simulation').then(
			(value: boolean) => {
				if (value) {
					this._esoService.cancelProductSimulation(
						data.Id,
						{
							name: `cancelProductSimulation -> [id: ${data.Id}]`,
							showLoadingIndicator: true,
							responseLoggingEnabled: false
						}
					).subscribe(
						{
							next: (statusMessageResult: StatusMessageResultDto) => {
								if (statusMessageResult.success) {

									let simulateMultiResult: SimulateMultiResult = this.simulateMultiResults.find((smr) => smr.Id === data.Id);

									simulateMultiResult.Status = 'Canceled';
									simulateMultiResult.EndTime = new Date();
									simulateMultiResult.CompletionTime = UtilsService.formatSecondsToTime(UtilsService.dateDifferenceInSeconds(simulateMultiResult.StartTime, simulateMultiResult.EndTime));

									this._notificationService.success(
										statusMessageResult.message
									);
								} else {
									this._notificationService.error(
										statusMessageResult.message
									);
								}
							}
						}
					);
				}
			}
		);
	}

	public onSimulationTrainingCancel(evt: any): void {

		const data = evt.row.data;

		confirm('Are you sure?', 'Cancel Training').then(
			(value: boolean) => {
				if (value) {
					this._esoService.cancelProductSimulationTraining(
						data.Id,
						{
							name: `cancelProductSimulationTraining -> [id: ${data.Id}]`,
							showLoadingIndicator: true,
							responseLoggingEnabled: false
						}
					).subscribe(
						{
							next: (statusMessageResult: StatusMessageResultDto) => {
								if (statusMessageResult.success) {

									let simulateMultiTrainingResult: SimulateMultiTrainingResult = this.simulateMultiTrainingResults.find((smtr) => smtr.Id === data.Id);

									simulateMultiTrainingResult.Status = 'Canceled';
									simulateMultiTrainingResult.EndTime = new Date();
									simulateMultiTrainingResult.CompletionTime = UtilsService.formatSecondsToTime(UtilsService.dateDifferenceInSeconds(simulateMultiTrainingResult.StartTime, simulateMultiTrainingResult.EndTime));

									this._notificationService.success(
										statusMessageResult.message
									);
								} else {
									this._notificationService.error(
										statusMessageResult.message
									);
								}
							}
						}
					);
				}
			}
		);
	}

	public getColorByStatus(status: 'Success' | 'Canceled' | 'Failure' | 'In Progress'): string {
		switch (status) {
			case 'Success':
				return 'rgb(34, 139, 34)';
			case 'Canceled':
				return 'rgb(192, 192, 192)';
			case 'Failure':
				return 'rgb(178, 34, 34)';
			case 'In Progress':
				return 'rgb(100, 149, 237)';
			default:
				return 'rgb(0, 0, 0)';
		}
	}


	private onReceiveSimulationInitializedSubscription: Subscription;
	private onReceiveSimulationTrainingInitiatedSubscription: Subscription;

	private onReceiveSimulationProgressUpdateSubscription: Subscription;
	private onReceiveSimulationTrainingProgressUpdateSubscription: Subscription;

	@Output() public onSimulationCompleted: EventEmitter<SimulateMultiResult> = new EventEmitter<SimulateMultiResult>();
	@Output() public onSimulationTrainingCompleted: EventEmitter<SimulateMultiTrainingResult> = new EventEmitter<SimulateMultiTrainingResult>();

	constructor(
		private _notificationService: NotificationService,

		private _esoService: EsoService,
		private _userService: UserService,

		private _signalRService: SignalRService,

		private _changeDetectorRef: ChangeDetectorRef,
	) { }

	ngOnInit() {

		this.onSimulationCancel = this.onSimulationCancel.bind(this);
		this.onSimulationTrainingCancel = this.onSimulationTrainingCancel.bind(this);

		this.onReceiveSimulationInitializedSubscription = this._signalRService.onReceiveSimulationInitiated.subscribe(
			{
				next: (response: SimulateMultiResult) => {

					this.simulateMultiResults.unshift(response);
					this.simulateMultiResultsInProgress.unshift(response);

					this._signalRService.startConnection()
						.then(() => this._signalRService.joinSimulationGroup(response.Id))
						.then(() => this.joinedSimIds.add(response.Id))
						.catch(err => console.error('Failed to join group for initiated simulation', err))

					this._changeDetectorRef.detectChanges();
				}
			}
		);

		this.onReceiveSimulationTrainingProgressUpdateSubscription = this._signalRService.onReceiveSimulationTrainingInitiated.subscribe(
			{
				next: (response: SimulateMultiTrainingResult) => {

					this.simulateMultiTrainingResults.unshift(response);
					this.simulateMultiTrainingResultsInProgress.unshift(response);

					this._changeDetectorRef.detectChanges();
				}
			}
		);

		this.onReceiveSimulationProgressUpdateSubscription =
			this._signalRService.onReceiveSimulationProgressUpdate
				.pipe(auditTime(100)) // ~10 updates/sec
				.subscribe({
					next: (response: SimulateMultiResult) => {
						let idx = this.simulateMultiResults.findIndex(i => i.Id === response.Id);
						let item = idx >= 0 ? this.simulateMultiResults[idx] : null;

						if (!item) {
							this.simulateMultiResults.unshift(response);
							this.simulateMultiResultsInProgress.unshift(response);
							item = this.simulateMultiResults[0];
						}

						item.SimulationsCompletedQuantity = response.SimulationsCompletedQuantity;
						item.Status = response.Status;

						if (response.EndTime) {
							this._signalRService.leaveSimulationGroup(response.Id)
								.then(() => this.joinedSimIds.delete(response.Id))
								.catch(() => {});

							item.EndTime = response.EndTime;
							item.CompletionTime = UtilsService.formatSecondsToTime(
								UtilsService.dateDifferenceInSeconds(response.StartTime, response.EndTime)
							);

							const indexToRemove = this.simulateMultiResultsInProgress.findIndex((it) => it.Id === response.Id);
							if (indexToRemove !== -1) this.simulateMultiResultsInProgress.splice(indexToRemove, 1);

							this.onSimulationCompleted.emit(item);
						}
					}
				});

		this.onReceiveSimulationTrainingProgressUpdateSubscription = this._signalRService.onReceiveSimulationTrainingProgressUpdate.subscribe(
			{
				next: (response: SimulateMultiTrainingResult) => {
					const simulateMultiTrainingResultIndex: number = this.simulateMultiTrainingResults.findIndex((item) => item.Id === response.Id);

					let simulateMultiTrainingResult: SimulateMultiTrainingResult = this.simulateMultiTrainingResults[simulateMultiTrainingResultIndex];

					simulateMultiTrainingResult.IterationsCompletedQuantity = response.IterationsCompletedQuantity;
					simulateMultiTrainingResult.Status = response.Status;

					if (response.EndTime) {
						simulateMultiTrainingResult.EndTime = response.EndTime;
						simulateMultiTrainingResult.CompletionTime = UtilsService.formatSecondsToTime(UtilsService.dateDifferenceInSeconds(response.StartTime, response.EndTime));

						// Remove the simulation training which is no longer 'In Progress'.
						const indexToRemove = this.simulateMultiTrainingResultsInProgress.findIndex((item) => item.Id === response.Id);

						if (indexToRemove !== -1) {
							this.simulateMultiTrainingResultsInProgress.splice(indexToRemove, 1);
						}

						this.onSimulationTrainingCompleted.emit(simulateMultiTrainingResult);
					}

					if (this._visible) {
						this._changeDetectorRef.detectChanges();

					}
				}
			}
		);
	}


	ngAfterViewInit() {
	}

	ngOnDestroy() {
		this.leaveAllJoinedGroups();

		if (this.onReceiveSimulationInitializedSubscription != null && this.onReceiveSimulationInitializedSubscription != undefined) {
			this.onReceiveSimulationInitializedSubscription.unsubscribe();
		}
		if (this.onReceiveSimulationProgressUpdateSubscription != null && this.onReceiveSimulationProgressUpdateSubscription != undefined) {
			this.onReceiveSimulationProgressUpdateSubscription.unsubscribe();
		}
		if (this.onReceiveSimulationTrainingProgressUpdateSubscription != null && this.onReceiveSimulationTrainingProgressUpdateSubscription != undefined) {
			this.onReceiveSimulationTrainingProgressUpdateSubscription.unsubscribe();
		}
	}
}
